import {spaceNumber} from "../../../utils/numerals/spaceNumber";

export const updateNumbers = (animationId, duration, ...objects) => {
	const start = performance.now();
	objects.forEach( (obj) => {
		if ( obj.endValue && obj.startValue )
		{
			obj.diff = obj.endValue - obj.startValue;
		}
	} );

	const animate = (time) => {
		const timeFraction = (time - start) / duration;
		objects.forEach( (obj) => {
			if ( obj.container && obj.endValue && obj.startValue )
			{
				const value = Math.floor(timeFraction * 100 * obj.diff / 100);
				const newValue = spaceNumber( obj.startValue + value ).replace(/ /g, `&nbsp;`) + `&nbsp;`;
				obj.container.innerHTML = obj.container.textContent.replace(/(\D+)?[\d ]+(.+)/giy, `$1${newValue}$2`);
			}
		} );

		if ( timeFraction <= 1 )
		{
			animationId = requestAnimationFrame(animate);
		} else
		{
			objects.forEach( (obj) => {
				if ( obj.container && obj.endValue && obj.startValue )
				{
					const newValue = spaceNumber( obj.endValue ).replace(/ /g, `&nbsp;`) + `&nbsp;`;
					obj.container.innerHTML = obj.container.textContent.replace(/(\D+)?[\d ]+(.+)/giy, `$1${newValue}$2`);
				}
			} );
		}
	};

	animationId = requestAnimationFrame(animate);
};
